import { Backdrop } from '../../../common';
import { useLayoutStore } from '../../../layout';
import { useMenuStore } from '../../stores';
import { MenuDesktop } from './desktop/MenuDesktop';
import { MenuMobile } from './mobile/MenuMobile';

export function Menu() {
  const isDesktop = useLayoutStore.use.isDesktop();
  const isMobile = useLayoutStore.use.isMobile();
  const isMenuOpen = useMenuStore.use.isMenuOpen();
  const setMenuOpen = useMenuStore.use.setMenuOpen();
  const setSelectedCategory = useMenuStore.use.setSelectedCategory();

  const close = () => {
    setMenuOpen(false);
    setSelectedCategory(null);
  };

  return (
    <>
      <Backdrop
        name="menu"
        open={isMenuOpen}
        onClick={close}
        onMouseMove={() => isDesktop && close()}
        canChangeBodyOverFlow={isMobile && isMenuOpen}
      />
      <MenuDesktop />
      <MenuMobile />
    </>
  );
}
